_getUserLocalDataLanguageAlertBarAccepted